module.exports = __webpack_public_path__ + "img/usps-logo.b45a8128.svg";